module.exports = __webpack_public_path__ + "img/back1.c5e3c049.png";